import metaLoader from './meta-loader';
import metaTranslationsLoader from './meta-tranlsations-loader';
import templateFetcher from './template-fetcher';

export default {
  metaLoader,
  metaTranslationsLoader,
  templateFetcher,
};
